"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.renderValue = exports.formatValue = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_intl_1 = require("react-intl");
var styles_1 = require("./styles");
var Typography_1 = __importDefault(require("../Typography"));
var formatValue = function (value, intl) {
    if (value instanceof Date) {
        return intl.formatDate(value, { month: 'numeric', year: 'numeric' });
    }
    return value;
};
exports.formatValue = formatValue;
var renderValue = function (value, intl) {
    if (value instanceof Date || typeof value === 'number' || typeof value === 'string') {
        return ((0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ bold: true, size: "lg" }, { children: (0, exports.formatValue)(value, intl) })));
    }
    return value;
};
exports.renderValue = renderValue;
var Item = function (_a) {
    var label = _a.label, value = _a.value, noSeparator = _a.noSeparator, rest = __rest(_a, ["label", "value", "noSeparator"]);
    var intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)(styles_1.ItemContainer, __assign({ "data-testid": rest['data-testid'], noSeparator: noSeparator }, { children: [(0, jsx_runtime_1.jsx)(styles_1.ItemLabel, __assign({ "data-testid": "".concat(rest['data-testid'], "-label") }, { children: label })), (0, jsx_runtime_1.jsx)(styles_1.ItemValue, __assign({ "data-testid": "".concat(rest['data-testid'], "-value") }, { children: (0, exports.renderValue)(value, intl) }))] })));
};
exports.Item = Item;
